"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1946],{

/***/ 93853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 238 modules
var es = __webpack_require__(67763);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js
var FormField = __webpack_require__(23341);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@pcln/date-picker/dist/esm/index.js + 67 modules
var esm = __webpack_require__(32018);
// EXTERNAL MODULE: ./node_modules/@pcln/experimentation/dist/esm/index.js + 4 modules
var dist_esm = __webpack_require__(80460);
// EXTERNAL MODULE: ./node_modules/@pcln/fly-date-picker/dist/esm/AirPricedCalendar/AirPricedCalendar.js + 9 modules
var AirPricedCalendar = __webpack_require__(96678);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(64298);
// EXTERNAL MODULE: ./src/components/CalenderWrapperBox.styled.ts
var CalenderWrapperBox_styled = __webpack_require__(2850);
// EXTERNAL MODULE: ./src/components/DateField.tsx
var DateField = __webpack_require__(43484);
// EXTERNAL MODULE: ./src/components/ShadowEffect.tsx
var ShadowEffect = __webpack_require__(10843);
// EXTERNAL MODULE: ./src/components/TypeAhead/index.tsx + 13 modules
var TypeAhead = __webpack_require__(21993);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(45588);
// EXTERNAL MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx + 9 modules
var TravelerSelection = __webpack_require__(47941);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useTabGroup.ts
var useTabGroup = __webpack_require__(78474);
// EXTERNAL MODULE: ./src/components/SearchFormButton/index.tsx
var SearchFormButton = __webpack_require__(17975);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/utils/error-helpers.ts
var error_helpers = __webpack_require__(75720);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
;// CONCATENATED MODULE: ./src/components/AmbiguousCityLink/index.tsx



var AmbiguousCityLink = function(param) {
    var handleCallback = param.handleCallback, city = param.city;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: [
            2,
            null,
            1
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
            type: "button",
            variation: "link",
            onClick: function(e) {
                e.preventDefault();
                handleCallback();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                fontSize: 0,
                children: [
                    "Looking for a different ",
                    city,
                    "?"
                ]
            })
        })
    });
};
/* harmony default export */ var components_AmbiguousCityLink = (AmbiguousCityLink);

// EXTERNAL MODULE: ./src/components/BundleAndSave/BundleAndSave.tsx
var BundleAndSave = __webpack_require__(18103);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(39997);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Plus.js
var Plus = __webpack_require__(97121);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Minus.js
var Minus = __webpack_require__(22125);
// EXTERNAL MODULE: ./src/components/Flights/SearchForm/utils.ts
var SearchForm_utils = __webpack_require__(91753);
// EXTERNAL MODULE: ./src/components/Flights/constants.ts
var Flights_constants = __webpack_require__(33765);
;// CONCATENATED MODULE: ./src/components/Flights/SearchForm/MultiDestination.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n  height: 48px !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var Close = (0,styled_components_browser_esm/* default */.ZP)(CloseButton/* default */.Z).withConfig({
    componentId: "sc-9fa912bf-0"
})(_templateObject());
function MultiDestination(param) {
    var flights = param.flights, errors = param.errors, setValue = param.setValue, isMobile = param.isMobile;
    var ref = (0,react.useState)((0,es/* repeat */.rx1)(false, 4)), isCalendarOpen = ref[0], setIsCalendarOpen = ref[1];
    var typeaheadWidth = [
        1,
        null,
        1 / 2,
        null,
        1 / 3
    ];
    var startLocationPlaceholder = "Departing from?";
    var endLocationPlaceholder = "Going to?";
    var datePickerLabel = "Departing";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            flights.slice(1).map(function(flight, index) {
                var flightIndex = index + 1;
                var datePickerAriaLabel = "Departing Date Picker ".concat(flightIndex + 1);
                var startLocationSearchKey = (0,SearchForm_utils/* flightsStartLocationSearchKey */.ND)(flightIndex);
                var endLocationSearchKey = (0,SearchForm_utils/* flightsEndLocationSearchKey */.jm)(flightIndex);
                var dateRangeKey = (0,SearchForm_utils/* flightsDateRangeKey */.fv)(flightIndex);
                var _startLocation, _endLocation, _startDate, _endDate;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mx: -2,
                    flexWrap: "wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: typeaheadWidth,
                            p: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                enabled: true,
                                forProperty: startLocationSearchKey,
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                        searchProduct: "flights",
                                        placeholder: startLocationPlaceholder,
                                        label: startLocationPlaceholder,
                                        searchKey: startLocationSearchKey,
                                        errors: errors,
                                        defaultSelectedItem: (_startLocation = flight.startLocation) !== null && _startLocation !== void 0 ? _startLocation : null,
                                        disableShadowState: disableShadowState,
                                        onItemSelect: function(item) {
                                            (0,SearchForm_utils/* setFlights */.zX)(flights, {
                                                startLocation: item
                                            }, setValue, flightIndex);
                                        }
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: typeaheadWidth,
                            p: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                enabled: true,
                                forProperty: endLocationSearchKey,
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                        searchProduct: "flights",
                                        placeholder: endLocationPlaceholder,
                                        label: endLocationPlaceholder,
                                        searchKey: endLocationSearchKey,
                                        errors: errors,
                                        defaultSelectedItem: (_endLocation = flight.endLocation) !== null && _endLocation !== void 0 ? _endLocation : null,
                                        disableShadowState: disableShadowState,
                                        onItemSelect: function(item) {
                                            (0,SearchForm_utils/* setFlights */.zX)(flights, {
                                                endLocation: item
                                            }, setValue, flightIndex);
                                        }
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "stretch",
                            width: [
                                1,
                                null,
                                null,
                                null,
                                1 / 3
                            ],
                            px: 2,
                            py: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    forProperty: dateRangeKey,
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                            "data-calendar": true,
                                            open: isCalendarOpen[index],
                                            position: "right",
                                            onDismiss: function() {
                                                setIsCalendarOpen((0,es/* update */.Vxg)(index, false, isCalendarOpen));
                                                disableShadowState();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                        m: 0,
                                                        width: 1 / 2,
                                                        id: dateRangeKey,
                                                        name: dateRangeKey,
                                                        label: datePickerLabel,
                                                        placeholder: datePickerLabel,
                                                        value: (0,date_helper/* getDateRange */.Y_)({
                                                            departureDate: (_startDate = flight.startDate) !== null && _startDate !== void 0 ? _startDate : null,
                                                            arrivalDate: (_endDate = flight.endDate) !== null && _endDate !== void 0 ? _endDate : null
                                                        }, true),
                                                        onFocus: function() {
                                                            setIsCalendarOpen((0,es/* update */.Vxg)(index, true, isCalendarOpen));
                                                        // analytics call for handleCalendarOnFocus(`datefield ${i}`)
                                                        },
                                                        error: (0,error_helpers/* getDateFieldErrorMessage */.Q4)(errors, flightIndex),
                                                        errorZIndex: 1,
                                                        hideTooltip: isCalendarOpen[index] || !!flight.startDate,
                                                        color: (0,error_helpers/* getDateFieldBorderColors */.Mx)(errors, flightIndex),
                                                        "data-testid": "FLIGHTS_TRAVEL_DATES_INPUT_".concat(flightIndex),
                                                        "aria-label": datePickerAriaLabel,
                                                        "aria-expanded": isCalendarOpen[index]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirPricedCalendar/* AirPricedCalendar */.g, {
                                                        monthWidthPx: 300,
                                                        id: "flight-date-range-calendar-".concat(flightIndex),
                                                        onChange: function(_e, dates) {
                                                            var _startDate = dates.startDate, startDate = _startDate === void 0 ? "" : _startDate;
                                                            var dateObj = {
                                                                startDate: startDate
                                                            };
                                                            (0,SearchForm_utils/* setFlights */.zX)(flights, dateObj, setValue, flightIndex);
                                                            disableShadowState();
                                                            setIsCalendarOpen((0,es/* update */.Vxg)(index, false, isCalendarOpen));
                                                        },
                                                        minDate: (0,SearchForm_utils/* getPrevDate */.dD)(flights, flightIndex),
                                                        startDate: flight.startDate,
                                                        selectTwoDates: false,
                                                        allowSameDay: false,
                                                        flightDetails: {
                                                            cabinClass: "Economy",
                                                            flights: flights,
                                                            tripType: Flights_constants/* MULTI_DESTINATION */.N2
                                                        },
                                                        variantName: "EXPRESS",
                                                        useDefaultFooter: true,
                                                        onDismiss: function() {
                                                            disableShadowState();
                                                            setIsCalendarOpen((0,es/* update */.Vxg)(index, false, isCalendarOpen));
                                                        }
                                                    })
                                                })
                                            ]
                                        }, "dates");
                                    }
                                }),
                                flightIndex > 0 && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
                                    "aria-label": "remove flight",
                                    id: "remove-flight-button",
                                    ml: 2,
                                    onClick: function(e) {
                                        e.preventDefault();
                                        (0,SearchForm_utils/* removeFlight */.xR)(flights, flightIndex, setValue);
                                    },
                                    title: "Remove flight"
                                })
                            ]
                        })
                    ]
                }, flightIndex);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                py: 2,
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mx: -1,
                    alignItems: "center",
                    justifyContent: "stretch",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            variation: "outline",
                            "aria-label": "add flight",
                            disabled: (flights === null || flights === void 0 ? void 0 : flights.length) > 4,
                            id: "mobile-add-flight-button",
                            mx: 1,
                            onClick: function(e) {
                                e.preventDefault();
                                (0,SearchForm_utils/* addFlight */.gY)(flights, setValue);
                            },
                            size: "small",
                            width: 1 / 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {
                                size: 24
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            variation: "outline",
                            "aria-label": "remove flight",
                            disabled: (flights === null || flights === void 0 ? void 0 : flights.length) < 2,
                            id: "mobile-remove-flight-button",
                            mx: 1,
                            onClick: function(e) {
                                e.preventDefault();
                                (0,SearchForm_utils/* removeFlight */.xR)(flights, flights.length - 1, setValue);
                            },
                            size: "small",
                            width: 1 / 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                size: 24
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    variation: "outline",
                    "aria-label": "add flight",
                    disabled: (flights === null || flights === void 0 ? void 0 : flights.length) > 4,
                    id: "add-flight-button",
                    onClick: function(e) {
                        e.preventDefault();
                        (0,SearchForm_utils/* addFlight */.gY)(flights, setValue);
                    },
                    pl: "12px",
                    size: "medium",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {
                                size: 24
                            }),
                            "Add another flight"
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/Flights/SearchForm/validation.ts



var MAXIMUM_BUNDLE_GUEST_COUNT = 8;
var AIRPORT_ERROR = "Please enter an airport";
var DISALLOW_INFANT_INTL_FLIGHT = "Sorry, we do not offer lap infant seating on international flights";
var INFANT_CAPACITY_LIMIT = "Only one infant per adult is allowed";
var BUNDLE_MAX_CAPACITY_ERROR = "Bundles accommodate up to 8 people. You may need an additional bundle for your group";
var isInternational = function(locationObject) {
    var countryCode = locationObject.countryCode.toUpperCase();
    return countryCode !== undefined && countryCode !== "US";
};
var hasAnyInternational = function(locationObjects) {
    return locationObjects.some(isInternational);
};
function handleInfantTravel() {
    var _parent = this.parent, adultCount = _parent.adultCount, flights = _parent.flights, infantCount = _parent.infantCount;
    var hasInfant = infantCount > 0;
    var isInValid = flights.some(function(flight) {
        var startLocation = flight.startLocation, endLocation = flight.endLocation;
        var hasInternational = hasAnyInternational([
            startLocation,
            endLocation
        ].filter(Boolean));
        return hasInfant && hasInternational;
    });
    if (isInValid === true) {
        return this.createError({
            message: DISALLOW_INFANT_INTL_FLIGHT,
            path: this.path
        });
    }
    if (adultCount < infantCount) {
        return this.createError({
            message: INFANT_CAPACITY_LIMIT,
            path: this.path
        });
    }
    return true;
}
function handleRoomCapacity() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenCount = _parent.childrenCount, tripType = _parent.tripType, infantCount = _parent.infantCount, youthCount = _parent.youthCount;
    var travelerCount = adultCount + childrenCount + infantCount + youthCount;
    if (MAXIMUM_BUNDLE_GUEST_COUNT < travelerCount && (tripType.includes(Flights_constants/* HOTEL */.IN) || tripType.includes(Flights_constants/* DRIVE */.cv))) {
        return this.createError({
            message: BUNDLE_MAX_CAPACITY_ERROR,
            path: this.path
        });
    }
    return true;
}
var SCHEMA_OW = yup_es/* object */.Ry().shape({
    endLocation: yup_es/* object */.Ry().transform(function(val) {
        return (0,es/* isEmpty */.xbD)(val) || val === null ? undefined : val;
    }).required(AIRPORT_ERROR).test("identical locations", "Departure and arrival airport can't be the same", function testOneWaySchema(val) {
        var ref = this.resolve(yup_es/* ref */.iH("startLocation"));
        if ((0,es/* equals */.fS0)(ref, val)) {
            return false;
        }
        return true;
    }),
    startDate: yup_es/* string */.Z_().required(),
    startLocation: yup_es/* object */.Ry().transform(function(val) {
        return (0,es/* isEmpty */.xbD)(val) || val === null ? undefined : val;
    }).required(AIRPORT_ERROR)
});
var SCHEMA_RT = SCHEMA_OW.concat(yup_es/* object */.Ry().shape({
    endDate: yup_es/* string */.Z_().required()
}));
var searchFormSchema = yup_es/* object */.Ry({
    flightType: yup_es/* string */.Z_(),
    flights: yup_es/* array */.IX().when("flightType", {
        is: function(val) {
            return val === Flights_constants/* ONE_WAY */.KW || val === Flights_constants/* MULTI_DESTINATION */.N2;
        },
        then: yup_es/* array */.IX().of(SCHEMA_OW),
        otherwise: yup_es/* array */.IX().of(SCHEMA_RT)
    }),
    infantCount: yup_es/* number */.Rx().test({
        name: "infantCount",
        test: handleInfantTravel
    }),
    roomCount: yup_es/* number */.Rx().test({
        name: "roomCount",
        test: handleRoomCapacity
    })
});
/* harmony default export */ var validation = (searchFormSchema);

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Radio/Radio.js + 2 modules
var Radio = __webpack_require__(47503);
;// CONCATENATED MODULE: ./src/components/Flights/SearchForm/FlightTypeRadios.tsx

function FlightTypeRadios_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    FlightTypeRadios_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var FlightTypeLabel = (0,styled_components_browser_esm/* default */.ZP)(Label/* default */.Z).withConfig({
    componentId: "sc-7e290ad7-0"
})(FlightTypeRadios_templateObject());
var gaTrackingTripType = function(key, flightType) {
    var flightsCategory = key === "flights" ? constants_analytics/* ANALYTICS_CATEGORY_FLIGHTS */.y1 : constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG;
    analytics/* default.fireEvent */.Z.fireEvent({
        category: flightsCategory,
        action: "Flights Trip Type",
        label: flightType
    });
};
function FlightTypeRadios(param) {
    var flightTypesToDisplay = param.flightTypesToDisplay, setValue = param.setValue, flightType = param.flightType, register = param.register, flights = param.flights;
    var key = (0,react.useContext)(BootstrapDataContext/* default */.Z).key;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: flightTypesToDisplay.map(function(flightInfo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mr: 3,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlightTypeLabel, {
                    fontSize: [
                        10,
                        12
                    ],
                    fontWeight: 500,
                    nowrap: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                            id: flightInfo.id,
                            "data-testid": flightInfo.id,
                            name: "flightType",
                            checked: flightType === flightInfo.flightType,
                            value: flightInfo.flightType,
                            ref: register,
                            onChange: function(e) {
                                setValue("flightType", e.target.value);
                                gaTrackingTripType(key, flightInfo.flightType);
                                if (Array.isArray(flights) && flights.length > 1) {
                                    setValue("flights", [
                                        flights[0]
                                    ]);
                                }
                            }
                        }),
                        flightInfo.typeLabel
                    ]
                })
            }, flightInfo.id);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Flights/SearchForm/FlightFormBanner.tsx



function FlightFormBannerHandler(param) {
    var isRebook = param.isRebook, bundleAndSave = param.bundleAndSave, rebookBanner = param.rebookBanner, bundleAndSaveMobileWidth = param.bundleAndSaveMobileWidth, isFlightTypeMultiDestination = param.isFlightTypeMultiDestination, showBundleAndSave = param.showBundleAndSave, isMobile = param.isMobile;
    var showBundleAndSaveWrapper = function() {
        return showBundleAndSave && bundleAndSave;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: !isFlightTypeMultiDestination ? [
            1,
            null,
            1 / 2
        ] : 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: isMobile ? bundleAndSaveMobileWidth : [
                0,
                null,
                1
            ],
            py: 2,
            mt: isMobile ? 1 : null,
            children: isRebook ? rebookBanner : !isFlightTypeMultiDestination && showBundleAndSaveWrapper()
        })
    });
}

// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Discount.js
var Discount = __webpack_require__(72027);
;// CONCATENATED MODULE: ./src/components/Flights/SearchForm/RebookBanner.tsx




function RebookBanner(param) {
    var credit = param.credit, airline = param.airline;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        p: 1,
        borderRadius: "lg",
        height: "56px",
        color: "highlight.light",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Discount/* default */.Z, {
                    m: 1,
                    mr: 2,
                    color: "success.dark"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    pr: [
                        1,
                        2,
                        null,
                        3
                    ],
                    color: "success.dark",
                    bold: true,
                    fontSize: [
                        0,
                        null,
                        null,
                        null,
                        1
                    ],
                    m: "auto",
                    ml: 0,
                    children: "Your ".concat(credit, " credit with ").concat(airline, " will be applied to all eligible flights.")
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Flights/SearchForm/Form.tsx
/* eslint-disable @typescript-eslint/unbound-method */ // eslint-disable can be removed after upgrade to react-hook-form v7 - https://github.com/react-hook-form/react-hook-form/issues/2887




function Form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  pointer-events: ",
        ";\n  cursor: pointer;\n  height: 56px;\n"
    ]);
    Form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

































var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-3a6639dd-0"
})(Form_templateObject(), function(props) {
    return props.isRebook ? (0,utils/* getPaletteColor */.ow)("background.tint") : (0,utils/* getPaletteColor */.ow)("background.lightest");
}, function(props) {
    return props.isRebook ? "none" : "auto";
});
function Form(param) {
    var _isRebook = param.isRebook, isRebook = _isRebook === void 0 ? false : _isRebook, onSubmit = param.onSubmit, _flightTypes = param.flightTypes, flightTypes = _flightTypes === void 0 ? [
        Flights_constants/* FLIGHT_TYPE_INFO */.Yt[Flights_constants/* ROUND_TRIP */.iF],
        Flights_constants/* FLIGHT_TYPE_INFO */.Yt[Flights_constants/* ONE_WAY */.KW],
        Flights_constants/* FLIGHT_TYPE_INFO */.Yt[Flights_constants/* MULTI_DESTINATION */.N2]
    ] : _flightTypes, promoDeal = param.promoDeal;
    var registerOriginAmbiguousElement = function registerOriginAmbiguousElement(ref) {
        ambiguousOriginElement.current = ref;
    };
    var registerDestAmbiguousElement = function registerDestAmbiguousElement(ref) {
        ambiguousDestElement.current = ref;
    };
    var ref, ref1;
    var ref2 = (0,useTabGroup/* default */.Z)(), registerTabElement = ref2.registerTabElement, focusNextElement = ref2.focusNextElement;
    var ref3 = (0,react.useContext)(BootstrapDataContext/* default */.Z), isMobile = ref3.isMobile, prePopData = ref3.prePopData, webstats = ref3.webstats, customer = ref3.customer, flightRebookDetails = ref3.flightRebookDetails;
    var ref4;
    var ref5 = (ref4 = prePopData === null || prePopData === void 0 ? void 0 : prePopData.flights) !== null && ref4 !== void 0 ? ref4 : {}, flights = ref5.flights, flightType = ref5.flightType, cabinClass = ref5.cabinClass, adultCount = ref5.adultCount, youthCount = ref5.youthCount, childrenCount = ref5.childrenCount, infantCount = ref5.infantCount;
    var initialValue = (0,_object_spread/* default */.Z)({}, SearchForm_utils/* initialState */.E3, flights && {
        flights: flights
    }, flightType && {
        flightType: flightType
    }, cabinClass && {
        cabinClass: cabinClass
    }, adultCount && {
        adultCount: adultCount
    }, youthCount && {
        youthCount: youthCount
    }, childrenCount && {
        childrenCount: childrenCount
    }, infantCount && {
        infantCount: infantCount
    }, isRebook && flightRebookDetails && (0,_object_spread/* default */.Z)({
        cabinClass: flightRebookDetails.cabinClass
    }, flightRebookDetails.passengerCount));
    var ref6;
    var rebookCarrierName = (ref6 = flightRebookDetails === null || flightRebookDetails === void 0 ? void 0 : flightRebookDetails.carrierName) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var rebookCreditAmount = (ref7 = flightRebookDetails === null || flightRebookDetails === void 0 ? void 0 : flightRebookDetails.creditAmount) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8 = (0,react_hook_form_es/* useForm */.cI)({
        defaultValues: initialValue,
        mode: "onSubmit",
        validationSchema: validation,
        reValidateMode: "onChange"
    }), errors = ref8.errors, handleSubmit = ref8.handleSubmit, register = ref8.register, setValue = ref8.setValue, triggerValidation = ref8.triggerValidation, unregister = ref8.unregister, watch = ref8.watch;
    var ref9 = watch({
        nest: true
    }), watchAdultCount = ref9.adultCount, watchCabinClass = ref9.cabinClass, watchChildrenAges = ref9.childrenAges, watchChildrenCount = ref9.childrenCount, watchInfantCount = ref9.infantCount, watchFlightType = ref9.flightType, watchFlights = ref9.flights, watchRoomCount = ref9.roomCount, watchTripType = ref9.tripType, watchYouthCount = ref9.youthCount;
    var ref10 = (0,router.useRouter)(), query = ref10.query, pathname = ref10.pathname;
    var ambigOriginCity = query["ambig-origin-city"], ambigDestCity = query["ambig-dest-city"];
    var isHomepage = pathname === "/";
    var ANALYTICS_CATEGORY = constants_analytics/* ANALYTICS_CATEGORIES */.ZP[pathname];
    (0,react.useEffect)(function() {
        SearchForm_utils/* fields.forEach */.XU.forEach(function(name) {
            register({
                name: name
            });
        });
        return function() {
            SearchForm_utils/* fields.forEach */.XU.forEach(function(name) {
                unregister(name);
            });
        };
    }, [
        register,
        unregister
    ]);
    (0,react.useEffect)(function() {
        triggerValidation("roomCount");
    }, [
        triggerValidation,
        watchAdultCount,
        watchChildrenCount,
        watchInfantCount,
        watchTripType,
        watchRoomCount,
        watchYouthCount
    ]);
    (0,react.useEffect)(function() {
        if (!(0,es/* isEmpty */.xbD)(errors)) {
            triggerValidation("flights");
            var gaLabel = "".concat(constants_analytics/* INVALID */.UI, " -");
            if (errors.flights) {
                errors.flights.forEach(function(flight, index) {
                    var invalidFlightFields = Object.keys(flight);
                    gaLabel += " Flight ".concat(index + 1, ": ").concat(invalidFlightFields.join("| "));
                });
            }
            if (errors.roomCount) gaLabel += " | roomCount";
            if (errors.infantCount) gaLabel += " | infantCount";
            analytics/* default.fireEvent */.Z.fireEvent({
                action: constants_analytics/* ANALYTICS_ACTION_FLIGHTS_SEARCH */.tu,
                category: ANALYTICS_CATEGORY,
                label: gaLabel
            });
        }
    }, [
        errors,
        triggerValidation,
        watchFlights,
        ANALYTICS_CATEGORY
    ]);
    (0,react.useEffect)(function() {
        triggerValidation("infantCount");
    }, [
        triggerValidation,
        watchFlights,
        watchInfantCount,
        watchAdultCount,
        watchChildrenAges
    ]);
    var ref11 = (0,react.useState)(false), isCalendarOpen = ref11[0], setIsCalendarOpen = ref11[1];
    var ref12 = (0,react.useState)(null), departureAirport = ref12[0], setDepartureAirport = ref12[1];
    var ref13 = (0,react.useState)(null), arrivalAirport = ref13[0], setArrivalAirport = ref13[1];
    var startLocationPlaceholder = "Departing from?";
    var endLocationPlaceholder = "Going to?";
    var isFlightTypeRoundTrip = (0,SearchForm_utils/* isRoundTrip */.SA)(watchFlightType);
    var isFlightTypeOneWay = (0,SearchForm_utils/* isOneWay */.kg)(watchFlightType);
    var isFlightTypeMultiDestination = (0,SearchForm_utils/* isMultiDestination */.i2)(watchFlightType);
    var isFlightTypeIncludeStay = (0,SearchForm_utils/* includesStay */.KK)(watchFlightType);
    var showCabinClass = (!isFlightTypeRoundTrip || !(0,SearchForm_utils/* isPackage */.JE)(watchTripType)) && !promoDeal;
    var showBundleAndSave = isFlightTypeRoundTrip && !promoDeal;
    var firstFlight = watchFlights[0] || {};
    var datePickerLabel = isFlightTypeRoundTrip ? "Departing - Returning" : "Departing";
    var datePickerAriaLabel = isFlightTypeOneWay || isFlightTypeMultiDestination ? "Departing Date Picker" : "Departing – Returning Date Picker";
    var maxDaysHotelToSelect = 30;
    var isPricedCalendarActive = !isFlightTypeMultiDestination;
    var CalendarComponent = isPricedCalendarActive ? AirPricedCalendar/* AirPricedCalendar */.g : esm/* Calendar */.f;
    var ref14 = (0,react.useState)(true), showOriginMoreCityLink = ref14[0], setShowOriginMoreCityLink = ref14[1];
    var origin = firstFlight === null || firstFlight === void 0 ? void 0 : (ref = firstFlight.startLocation) === null || ref === void 0 ? void 0 : ref.cityName;
    var showOriginDisambiguation = !!ambigOriginCity && !!origin && !isHomepage && showOriginMoreCityLink;
    var ambiguousOriginElement = (0,react.useRef)();
    var ref15 = (0,react.useState)(true), showDestMoreCityLink = ref15[0], setShowDestMoreCityLink = ref15[1];
    var destination = firstFlight === null || firstFlight === void 0 ? void 0 : (ref1 = firstFlight.endLocation) === null || ref1 === void 0 ? void 0 : ref1.cityName;
    var showDestDisambiguation = !!ambigDestCity && destination && !isHomepage && showDestMoreCityLink;
    var ambiguousDestElement = (0,react.useRef)();
    var clarifyAmbiguity = (0,react.useCallback)(function(element, flight, locationType) {
        var location = flight[locationType];
        return setTimeout(function() {
            if (element.current && location) {
                element.current.focus();
                setValue("flights", [
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, flight), (0,_define_property/* default */.Z)({}, locationType, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, location), {
                        itemName: location.cityName
                    })))
                ]);
            }
        }, 0);
    }, [
        setValue
    ]);
    var typeaheadWidth = [
        1,
        null,
        1 / 2,
        null,
        1 / 3
    ];
    var searchButtonContainerWidth = [
        1,
        null,
        showCabinClass ? 1 : 1 / 2,
        null,
        showCabinClass ? 1 / 3 : 1 / 2
    ];
    var bundleAndSaveMobileWidth = [
        1,
        null,
        showCabinClass ? 1 : 1 / 2,
        null,
        showCabinClass ? 1 / 3 : 1 / 2
    ];
    if (!isFlightTypeMultiDestination) {
        typeaheadWidth[4] = 1 / 2;
        searchButtonContainerWidth[4] = 1 / 2;
        bundleAndSaveMobileWidth[4] = 1 / 2;
    }
    // Fire Impression only in Flights Form
    var handleTypeaheadOpen = (0,react.useCallback)(function(isTypeaheadOpen) {
        if (isTypeaheadOpen) {
            dist_esm/* default.fireImpression */.Z.fireImpression("HP_FLIGHTS_TYPEAHEAD_HOVER");
        }
    }, []);
    var ref16, ref17, ref18, ref19;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(function(values) {
            return onSubmit((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                gaCategory: ANALYTICS_CATEGORY
            }), query);
        }),
        "data-testid": promoDeal ? "express-deal-form" : "form",
        "aria-label": promoDeal ? "flight-express-deal-search-form" : "flight-search-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightTypeRadios, {
                    flightTypesToDisplay: flightTypes,
                    flightType: watchFlightType,
                    setValue: setValue,
                    register: register,
                    flights: watchFlights
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mx: -2,
                flexWrap: "wrap",
                pb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        width: typeaheadWidth,
                        py: [
                            0,
                            null,
                            2
                        ],
                        px: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                enabled: true,
                                forProperty: (0,SearchForm_utils/* flightsStartLocationSearchKey */.ND)(0),
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                        onOpen: handleTypeaheadOpen,
                                        searchProduct: "flights",
                                        placeholder: startLocationPlaceholder,
                                        label: startLocationPlaceholder,
                                        searchKey: (0,SearchForm_utils/* flightsStartLocationSearchKey */.ND)(0),
                                        errors: errors,
                                        defaultSelectedItem: (ref16 = firstFlight === null || firstFlight === void 0 ? void 0 : firstFlight.startLocation) !== null && ref16 !== void 0 ? ref16 : {},
                                        disableShadowState: disableShadowState,
                                        ref: function(elem) {
                                            registerTabElement(elem);
                                            if (showOriginDisambiguation) {
                                                registerOriginAmbiguousElement(elem);
                                            }
                                        },
                                        onItemSelect: function(item) {
                                            (0,SearchForm_utils/* setFlights */.zX)(watchFlights, {
                                                startLocation: item
                                            }, setValue);
                                            setDepartureAirport(item);
                                            if ((item === null || item === void 0 ? void 0 : item.cityName) !== origin) {
                                                setShowOriginMoreCityLink(false);
                                            }
                                            if (!isMobile && !!item) {
                                                focusNextElement();
                                            }
                                        }
                                    });
                                }
                            }),
                            showOriginDisambiguation && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AmbiguousCityLink, {
                                city: origin,
                                handleCallback: function() {
                                    clarifyAmbiguity(ambiguousOriginElement, firstFlight, "startLocation");
                                    analytics/* default.fireEvent */.Z.fireEvent({
                                        action: "ambiguous-city",
                                        category: ANALYTICS_CATEGORY,
                                        label: "".concat(origin, " - flight origin")
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        width: typeaheadWidth,
                        py: [
                            0,
                            null,
                            2
                        ],
                        px: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                enabled: true,
                                forProperty: (0,SearchForm_utils/* flightsEndLocationSearchKey */.jm)(0),
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                        onOpen: handleTypeaheadOpen,
                                        searchProduct: "flights",
                                        placeholder: endLocationPlaceholder,
                                        label: endLocationPlaceholder,
                                        searchKey: (0,SearchForm_utils/* flightsEndLocationSearchKey */.jm)(0),
                                        errors: errors,
                                        defaultSelectedItem: (ref17 = firstFlight === null || firstFlight === void 0 ? void 0 : firstFlight.endLocation) !== null && ref17 !== void 0 ? ref17 : {},
                                        disableShadowState: disableShadowState,
                                        ref: function(elem) {
                                            registerTabElement(elem);
                                            if (showDestDisambiguation) {
                                                registerDestAmbiguousElement(elem);
                                            }
                                        },
                                        onItemSelect: function(item) {
                                            (0,SearchForm_utils/* setFlights */.zX)(watchFlights, {
                                                endLocation: item
                                            }, setValue);
                                            setArrivalAirport(item);
                                            if ((item === null || item === void 0 ? void 0 : item.cityName) !== destination) {
                                                setShowDestMoreCityLink(false);
                                            }
                                            if (!isMobile && !!item) {
                                                focusNextElement();
                                            }
                                        }
                                    });
                                }
                            }),
                            showDestDisambiguation && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AmbiguousCityLink, {
                                city: destination,
                                handleCallback: function() {
                                    clarifyAmbiguity(ambiguousDestElement, firstFlight, "endLocation");
                                    analytics/* default.fireEvent */.Z.fireEvent({
                                        action: "ambiguous-city",
                                        category: ANALYTICS_CATEGORY,
                                        label: "".concat(destination, " - flight destination")
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "baseline",
                        justifyContent: "stretch",
                        width: showCabinClass ? [
                            1,
                            null,
                            null,
                            null,
                            1 / 3
                        ] : [
                            1,
                            null,
                            1 / 2,
                            null,
                            1 / 2
                        ],
                        py: [
                            0,
                            null,
                            null,
                            2
                        ],
                        px: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                            forProperty: (0,SearchForm_utils/* flightsDateRangeKey */.fv)(0),
                            children: function(param) {
                                var disableShadowState = param.disableShadowState;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                    "data-calendar": true,
                                    open: isCalendarOpen,
                                    position: "left",
                                    onDismiss: function() {
                                        setIsCalendarOpen(false);
                                        disableShadowState();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                            m: 0,
                                            width: 1 / 2,
                                            id: (0,SearchForm_utils/* flightsDateRangeKey */.fv)(0),
                                            name: (0,SearchForm_utils/* flightsDateRangeKey */.fv)(0),
                                            ref: function(elem) {
                                                registerTabElement(elem);
                                            },
                                            label: datePickerLabel,
                                            placeholder: datePickerLabel,
                                            value: (0,date_helper/* getDateRange */.Y_)({
                                                departureDate: (ref18 = firstFlight === null || firstFlight === void 0 ? void 0 : firstFlight.startDate) !== null && ref18 !== void 0 ? ref18 : null,
                                                arrivalDate: (ref19 = firstFlight === null || firstFlight === void 0 ? void 0 : firstFlight.endDate) !== null && ref19 !== void 0 ? ref19 : null
                                            }, !isFlightTypeRoundTrip),
                                            onFocus: function() {
                                                setIsCalendarOpen(true);
                                            // analytics call for handleCalendarOnFocus(`datefield ${i}`)
                                            },
                                            error: (0,error_helpers/* getDateFieldErrorMessage */.Q4)(errors, 0, isFlightTypeRoundTrip),
                                            errorZIndex: 1,
                                            hideTooltip: isCalendarOpen || (isFlightTypeOneWay || isFlightTypeMultiDestination) && !!firstFlight.startDate || isFlightTypeRoundTrip && !!firstFlight.startDate && !!firstFlight.endDate,
                                            color: (0,error_helpers/* getDateFieldBorderColors */.Mx)(errors, 0),
                                            "data-testid": "FLIGHTS_TRAVEL_DATES_INPUT_".concat(0),
                                            "aria-label": datePickerAriaLabel,
                                            "aria-expanded": isCalendarOpen ? "true" : "false"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarComponent, {
                                                roundedCorners: true,
                                                monthWidthPx: 350,
                                                id: "flight-date-range-calendar-".concat(0),
                                                onChange: function(_e, dates) {
                                                    var _startDate = dates.startDate, startDate = _startDate === void 0 ? "" : _startDate, _endDate = dates.endDate, endDate = _endDate === void 0 ? "" : _endDate;
                                                    var dateObj = (0,_object_spread/* default */.Z)({
                                                        startDate: startDate
                                                    }, isFlightTypeRoundTrip && {
                                                        endDate: endDate
                                                    });
                                                    (0,SearchForm_utils/* setFlights */.zX)(watchFlights, dateObj, setValue);
                                                    if (!isFlightTypeRoundTrip || dates.startDate && dates.endDate) {
                                                        disableShadowState();
                                                        setIsCalendarOpen(false);
                                                    }
                                                },
                                                minDate: (0,SearchForm_utils/* getPrevDate */.dD)(watchFlights, 0),
                                                maxDaysToSelect: watchTripType.includes(Flights_constants/* HOTEL */.IN) && isFlightTypeRoundTrip ? maxDaysHotelToSelect : undefined,
                                                startDate: firstFlight.startDate,
                                                endDate: isFlightTypeRoundTrip ? firstFlight.endDate : undefined,
                                                selectTwoDates: isFlightTypeRoundTrip,
                                                allowSameDay: !isFlightTypeIncludeStay,
                                                flightDetails: {
                                                    cabinClass: watchCabinClass,
                                                    flights: [
                                                        {
                                                            departureAirport: departureAirport,
                                                            arrivalAirport: arrivalAirport
                                                        }
                                                    ],
                                                    tripType: watchFlightType
                                                },
                                                variantName: "EXPRESS",
                                                useDefaultFooter: isFlightTypeMultiDestination,
                                                onDismiss: function() {
                                                    disableShadowState();
                                                    setIsCalendarOpen(false);
                                                },
                                                useColorCode: !isFlightTypeMultiDestination,
                                                callFlexDatesGraphUrl: true
                                            })
                                        })
                                    ]
                                }, "dates");
                            }
                        })
                    }),
                    isFlightTypeMultiDestination && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        p: 2,
                        width: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDestination, {
                            flights: watchFlights,
                            setValue: setValue,
                            errors: errors,
                            isMobile: isMobile
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: [
                            1,
                            null,
                            1 / 2,
                            null,
                            showCabinClass ? 1 / 3 : 1 / 2
                        ],
                        py: [
                            0,
                            null,
                            2
                        ],
                        px: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                            enabled: true,
                            forProperty: "travelers-selection-readonly-input",
                            alternativeBlurHandling: true,
                            children: function(param) {
                                var disableShadowState = param.disableShadowState;
                                var ref, ref1;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TravelerSelection/* default */.Z, {
                                    disabled: isRebook,
                                    adultCount: watchAdultCount,
                                    childrenAges: watchChildrenAges,
                                    childrenCount: watchChildrenCount,
                                    disableShadowState: disableShadowState,
                                    disclaimer: constants/* FLIGHTS_DISCLAIMER */.PO,
                                    infantCount: watchInfantCount,
                                    isMobile: isMobile,
                                    onDoneButtonClick: disableShadowState,
                                    roomCount: watchRoomCount,
                                    setValue: setValue,
                                    showChildAgeSelectors: false,
                                    showInfantMenuItem: true,
                                    showRoomMenuItem: watchTripType.includes(Flights_constants/* HOTEL */.IN),
                                    showSubLabel: true,
                                    showYouthMenuItem: true,
                                    youthCount: watchYouthCount,
                                    error: (errors === null || errors === void 0 ? void 0 : (ref = errors.infantCount) === null || ref === void 0 ? void 0 : ref.message) || (errors === null || errors === void 0 ? void 0 : (ref1 = errors.roomCount) === null || ref1 === void 0 ? void 0 : ref1.message) || ""
                                });
                            }
                        })
                    }),
                    showCabinClass && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: [
                            1,
                            null,
                            1 / 2,
                            null,
                            1 / 3
                        ],
                        p: 2,
                        mt: [
                            2,
                            null,
                            0
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                            forProperty: "cabin-class-select",
                            children: function(param) {
                                var disableShadowState = param.disableShadowState;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                            autoHide: true,
                                            htmlFor: "cabin-class-select",
                                            color: isRebook ? (0,utils/* getPaletteColor */.ow)("text.base") : undefined,
                                            children: "Cabin Class"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                            isRebook: isRebook,
                                            disabled: isRebook,
                                            isMobile: isMobile,
                                            m: 0,
                                            id: "cabin-class-select",
                                            name: "cabinClass",
                                            value: watchCabinClass,
                                            onChange: function(e) {
                                                setValue("cabinClass", e.target.value);
                                                disableShadowState();
                                            /**  for GA tracking */ },
                                            children: Object.keys(Flights_constants/* CABIN_CLASS */.pH).map(function(name) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: name,
                                                    children: name
                                                }, name);
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightFormBannerHandler, {
                        isMobile: isMobile,
                        isRebook: isRebook,
                        bundleAndSaveMobileWidth: bundleAndSaveMobileWidth,
                        isFlightTypeMultiDestination: isFlightTypeMultiDestination,
                        showBundleAndSave: showBundleAndSave,
                        bundleAndSave: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            height: "56px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleAndSave/* default */.Z, {
                                category: ANALYTICS_CATEGORY,
                                productOptions: Flights_constants/* ADD_PRODUCT_OPTIONS */.Po,
                                tripType: watchTripType,
                                label: "Bundle + Save",
                                setValue: setValue
                            })
                        }),
                        rebookBanner: /*#__PURE__*/ (0,jsx_runtime.jsx)(RebookBanner, {
                            credit: rebookCreditAmount,
                            airline: rebookCarrierName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        width: searchButtonContainerWidth,
                        p: 2,
                        pb: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, {
                                buttonText: "Find Your Flight",
                                "data-testid": "FLIGHTS_SUBMIT_BUTTON",
                                handleClick: function() {
                                    if (isMobile) {
                                        var ref, ref1;
                                        window === null || window === void 0 ? void 0 : (ref = window.PCLN) === null || ref === void 0 ? void 0 : (ref1 = ref.pclnEventDispatcher) === null || ref1 === void 0 ? void 0 : ref1.dispatch("FIND_YOUR_FLIGHT");
                                    }
                                },
                                "data-rudder-event": true,
                                "data-sub-type": "search",
                                "data-source": isHomepage ? "homepage" : "flight landing",
                                "data-parent-product": "FLY",
                                "data-child-product": watchTripType.split(":").slice(1).join(":"),
                                "data-cguid": webstats.clientGUID,
                                "data-email-address": customer.emailAddress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                style: {
                                    left: !isMobile && isFlightTypeRoundTrip ? 0 : undefined,
                                    right: !isMobile && isFlightTypeRoundTrip ? 0 : undefined
                                },
                                pb: [
                                    3,
                                    null,
                                    0
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    fontSize: 0,
                                    textAlign: !isFlightTypeMultiDestination ? "center" : "left",
                                    mt: isMobile ? "12px" : 2,
                                    children: "Book a flight with free cancellation for flexibility"
                                })
                            })
                        ]
                    })
                ]
            }, 0)
        ]
    });
}


/***/ }),

/***/ 91753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "JE": function() { return /* binding */ isPackage; },
/* harmony export */   "KK": function() { return /* binding */ includesStay; },
/* harmony export */   "MI": function() { return /* binding */ onSubmit; },
/* harmony export */   "ND": function() { return /* binding */ flightsStartLocationSearchKey; },
/* harmony export */   "SA": function() { return /* binding */ isRoundTrip; },
/* harmony export */   "XU": function() { return /* binding */ fields; },
/* harmony export */   "dD": function() { return /* binding */ getPrevDate; },
/* harmony export */   "fv": function() { return /* binding */ flightsDateRangeKey; },
/* harmony export */   "gY": function() { return /* binding */ addFlight; },
/* harmony export */   "i2": function() { return /* binding */ isMultiDestination; },
/* harmony export */   "jm": function() { return /* binding */ flightsEndLocationSearchKey; },
/* harmony export */   "kg": function() { return /* binding */ isOneWay; },
/* harmony export */   "pZ": function() { return /* binding */ onSubmitExpressDeal; },
/* harmony export */   "xR": function() { return /* binding */ removeFlight; },
/* harmony export */   "zX": function() { return /* binding */ setFlights; }
/* harmony export */ });
/* unused harmony exports parseStringAndFormatAsDate, includesDrive, showCabinClass, flightSearchErrorStateAnalytics */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61436);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42298);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17563);
/* harmony import */ var _pcln_flodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45022);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67763);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94738);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66487);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29735);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33765);
/* harmony import */ var _Packages_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(360);










var DATE_FORMAT_UI = "MM/dd/yyyy";
var DATE_FORMAT_FORM_STATE = "yyyyMMdd";
function parseStringAndFormatAsDate(dateString, formatString) {
    var parsedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(dateString);
    if ((0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(parsedDate)) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(parsedDate, formatString);
    }
    return "";
}
function hasMultipleFlights(flightType, flights) {
    return Array.isArray(flights) && flights.length > 0 && (flightType === _constants__WEBPACK_IMPORTED_MODULE_6__/* .MULTI_DESTINATION */ .N2 || flightType === _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_CODE */ .RK[_constants__WEBPACK_IMPORTED_MODULE_6__/* .MULTI_DESTINATION */ .N2]);
}
function mapFormStateToSearchRequestType(formState, queryParams) {
    var flightType = formState.flightType, cabinClass = formState.cabinClass, flights = formState.flights, adultCount = formState.adultCount, youthCount = formState.youthCount, childrenCount = formState.childrenCount, infantCount = formState.infantCount;
    var flightTypeCode = flightType ? _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_CODE */ .RK[flightType] : "";
    var cabinClassCode = cabinClass ? _constants__WEBPACK_IMPORTED_MODULE_6__/* .CABIN_CLASS */ .pH[cabinClass] : "";
    var offerToken = typeof (queryParams === null || queryParams === void 0 ? void 0 : queryParams["offer-token"]) === "string" ? queryParams === null || queryParams === void 0 ? void 0 : queryParams["offer-token"] : "";
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        flightTypeCode: flightTypeCode,
        cabinClassCode: cabinClassCode,
        flightDetails: flights,
        adultCount: adultCount,
        youthCount: youthCount,
        childrenCount: childrenCount,
        infantCount: infantCount
    }, offerToken && {
        offerToken: offerToken
    });
}
/**
 * Each slice corresponds to one leg of a journey i.e. from A -> B on a certain date
 * one-way will have only one slice (A -> B)
 * round-trip will have only two slices (A -> B and B -> A)
 * multi-destination can have more than two slices (A -> B, B -> C, C -> D etc)
 * @param origination
 * @param destination
 * @param travelDate
 */ function buildSlice(origination, destination, travelDate) {
    return {
        origAirport: origination.id,
        destAirport: destination.id,
        origAirportType: origination.lat && origination.lon ? "0" : "1",
        destAirportType: destination.lat && destination.lon ? "0" : "1",
        departDate: parseStringAndFormatAsDate(travelDate, DATE_FORMAT_UI)
    };
}
function buildSlices(formRequestState) {
    var flightTypeCode = formRequestState.flightTypeCode, flightDetails = formRequestState.flightDetails;
    switch(flightTypeCode){
        case _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_CODE */ .RK[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ONE_WAY */ .KW]:
            if (!hasMultipleFlights(flightTypeCode, flightDetails)) {
                var ref = flightDetails[0], endLocation = ref.endLocation, startLocation = ref.startLocation, startDate = ref.startDate;
                return [
                    buildSlice(startLocation, endLocation, startDate)
                ];
            }
            break;
        case _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_CODE */ .RK[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_TRIP */ .iF]:
            if (!hasMultipleFlights(flightTypeCode, flightDetails)) {
                var ref1 = flightDetails[0], endLocation1 = ref1.endLocation, startLocation1 = ref1.startLocation, startDate1 = ref1.startDate, _endDate = ref1.endDate, endDate = _endDate === void 0 ? "" : _endDate;
                return [
                    buildSlice(startLocation1, endLocation1, startDate1),
                    buildSlice(endLocation1, startLocation1, endDate)
                ];
            }
            break;
        case _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_CODE */ .RK[_constants__WEBPACK_IMPORTED_MODULE_6__/* .MULTI_DESTINATION */ .N2]:
            if (hasMultipleFlights(flightTypeCode, flightDetails)) {
                return flightDetails.map(function(flightInfo) {
                    var endLocation = flightInfo.endLocation, startLocation = flightInfo.startLocation, startDate = flightInfo.startDate;
                    return buildSlice(startLocation, endLocation, startDate);
                });
            }
            break;
        default:
            break;
    }
    return [];
}
function buildRedirect(flightSearchRequestData) {
    var sopq = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var adultCount = flightSearchRequestData.adultCount, childrenCount = flightSearchRequestData.childrenCount, cabinClassCode = flightSearchRequestData.cabinClassCode, youthCount = flightSearchRequestData.youthCount, infantCount = flightSearchRequestData.infantCount, offerToken = flightSearchRequestData.offerToken;
    var options = {
        slices: buildSlices(flightSearchRequestData),
        totalPassengers: adultCount + (childrenCount !== null && childrenCount !== void 0 ? childrenCount : 0),
        params: {
            "cabin-class": cabinClassCode,
            "no-date-search": false
        },
        mListings: !sopq,
        dealsUrl: sopq,
        asUrl: false
    };
    options.params["search-type"] = options.slices.reduce(function(acc, param) {
        var origAirportType = param.origAirportType, destAirportType = param.destAirportType;
        return "".concat(acc).concat(origAirportType).concat(destAirportType);
    }, "");
    options.params["num-adults"] = adultCount;
    if (youthCount) {
        options.params["num-youths"] = youthCount;
    }
    if (childrenCount) {
        options.params["num-children"] = childrenCount;
    }
    if (infantCount) {
        options.params["num-infants"] = infantCount;
    }
    var refClickId = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .path */ .ETc)([
        "PCLN_BOOTSTRAP_DATA",
        "referral",
        "clickId"
    ], window);
    if (refClickId) {
        options.params.refclickid = refClickId;
        options.refclickid = refClickId;
    }
    if (offerToken) {
        options.params["offer-token"] = offerToken;
    }
    if (sopq) {
        // Takes a slice object and transforms it into a string
        // Ex. SFO-NYC-20201224
        var sliceStrings = options.slices.map(function(slice) {
            var origAirport = slice.origAirport.toUpperCase();
            var destAirport = slice.destAirport.toUpperCase();
            var formattedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(new Date(slice.departDate), DATE_FORMAT_FORM_STATE);
            return "".concat(origAirport, "-").concat(destAirport, "-").concat(formattedDate);
        });
        var concatenatedSlices = sliceStrings.join("/");
        var dealsPath = "m/fly/search/".concat(concatenatedSlices, "/deals/");
        var queryParams = query_string__WEBPACK_IMPORTED_MODULE_0__.stringify(options.params);
        var redirectUrl = "".concat(dealsPath, "?").concat(queryParams);
        return encodeURI(redirectUrl);
    }
    return (0,_pcln_flodash__WEBPACK_IMPORTED_MODULE_1__/* .urlCreator */ .JY)(options);
}
function searchRetail(formState, queryParams) {
    var flightSearchRequestData = mapFormStateToSearchRequestType(formState, queryParams);
    var deepLinkUrl = buildRedirect(flightSearchRequestData);
    if (deepLinkUrl) {
        window.open(deepLinkUrl, "_blank");
    }
}
function searchSOPQ(formState) {
    var isSOPQ = true;
    var flightSearchRequestData = mapFormStateToSearchRequestType(formState);
    var deepLinkUrl = buildRedirect(flightSearchRequestData, isSOPQ);
    if (deepLinkUrl) {
        window.open(deepLinkUrl, "_blank");
    }
}
var getChildrenData = function(youthCount, childrenCount, infantCount) {
    var childrenAges = [];
    return childrenAges.concat((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .times */ .DZ1)(function() {
        return 0;
    }, infantCount), (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .times */ .DZ1)(function() {
        return 14;
    }, childrenCount), (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .times */ .DZ1)(function() {
        return 17;
    }, youthCount));
};
var onSubmit = function(values, queryParams) {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: values.gaCategory,
        action: _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_ACTION_FLIGHTS_SEARCH */ .tu,
        label: values.flightType
    });
    var flight = values.flights[0];
    if ((values.tripType.includes("STAY") || values.tripType.includes("DRIVE")) && values.flightType === "round-trip") {
        var childrenCount = values.youthCount + values.childrenCount + values.infantCount;
        var childrenAges = getChildrenData(values.youthCount, values.childrenCount, values.infantCount);
        var _endDate, _endLocation, _startDate, _startLocation, _gaCategory;
        return (0,_Packages_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__/* .onSubmit */ .MI)({
            adultCount: values.adultCount,
            childrenAges: childrenAges,
            childrenCount: childrenCount,
            endDate: (_endDate = flight.endDate) !== null && _endDate !== void 0 ? _endDate : "",
            endLocation: (_endLocation = flight.endLocation) !== null && _endLocation !== void 0 ? _endLocation : null,
            partialStay: false,
            tripType: values.tripType,
            roomCount: values.roomCount,
            startDate: (_startDate = flight.startDate) !== null && _startDate !== void 0 ? _startDate : "",
            startLocation: (_startLocation = flight.startLocation) !== null && _startLocation !== void 0 ? _startLocation : null,
            gaCategory: (_gaCategory = values.gaCategory) !== null && _gaCategory !== void 0 ? _gaCategory : ""
        });
    }
    (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_5__/* .persistSearchData */ .al)(_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_5__/* .AIR_SEARCH_DATA */ .PP, values);
    searchRetail(values, queryParams);
};
var onSubmitExpressDeal = function(values) {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: values.gaCategory,
        action: _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_ACTION_FLIGHTS_SEARCH */ .tu,
        label: values.flightType
    });
    searchSOPQ(values);
};
var setFlights = function(flights, data, setValue) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var flightToAdd = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, flights[index], data);
    var result = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .update */ .Vxg)(index, flightToAdd, flights);
    setValue("flights", result);
};
var addFlight = function(flights, setValue) {
    var endLocation = (flights[flights.length - 1] || {}).endLocation;
    var nextFlight = {
        startLocation: endLocation,
        endLocation: {}
    };
    var result = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .append */ .R3I)(nextFlight, flights);
    setValue("flights", result);
};
var removeFlight = function(flights, index, setValue) {
    var result = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .remove */ .OdJ)(index, 1, flights);
    setValue("flights", result);
};
var getPrevDate = function(flights, index) {
    var dateFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DATE_FORMAT_FORM_STATE;
    var defaultDate = parseStringAndFormatAsDate(new Date().toISOString(), dateFormat);
    if (index > 0) {
        var ref = flights[index - 1], _startDate = ref.startDate, startDate = _startDate === void 0 ? "" : _startDate;
        return startDate ? parseStringAndFormatAsDate(startDate, dateFormat) : defaultDate;
    }
    return defaultDate;
};
var initialState = {
    flightType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_TRIP */ .iF,
    flights: [
        {
            startLocation: {},
            endLocation: {},
            startDate: ""
        }
    ],
    tripType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLY */ .wd,
    cabinClass: "Economy",
    roomCount: 1,
    adultCount: 1,
    youthCount: 0,
    infantCount: 0,
    childrenCount: 0,
    childrenAges: [],
    gaCategory: _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_CATEGORY_FLIGHTS */ .y1
};
var fields = [
    "flights",
    "flightType",
    "roomCount",
    "adultCount",
    "childrenAges",
    "childrenCount",
    "infantCount",
    "youthCount",
    "tripType",
    "flightType",
    "cabinClass",
    "gaCategory"
];
var isOneWay = function(flightType) {
    return flightType === _constants__WEBPACK_IMPORTED_MODULE_6__/* .ONE_WAY */ .KW;
};
var isRoundTrip = function(flightType) {
    return flightType === _constants__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_TRIP */ .iF;
};
var isMultiDestination = function(flightType) {
    return flightType === _constants__WEBPACK_IMPORTED_MODULE_6__/* .MULTI_DESTINATION */ .N2;
};
var includesStay = function(tripType) {
    return tripType.includes(_constants__WEBPACK_IMPORTED_MODULE_6__/* .HOTEL */ .IN);
};
var includesDrive = function(tripType) {
    return tripType.includes(_constants__WEBPACK_IMPORTED_MODULE_6__/* .DRIVE */ .cv);
};
var isPackage = function(tripType) {
    return includesStay(tripType) || includesDrive(tripType);
};
var showCabinClass = function(flightType, tripType) {
    return !isPackage(tripType) || isOneWay(flightType) || isMultiDestination(flightType);
};
var flightsStartLocationSearchKey = function(index) {
    return "flights.".concat(index, ".startLocation");
};
var flightsEndLocationSearchKey = function(index) {
    return "flights.".concat(index, ".endLocation");
};
var flightsDateRangeKey = function(index) {
    return "flight-date-range-".concat(index);
};
var flightSearchErrorStateAnalytics = function(errors) {
    var errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
        var errorProps = errorKeys.reduce(function(errMsg, errorKey) {
            return "".concat(errMsg, " | ").concat(errorKey);
        });
        var data = "".concat(INVALID, " - ").concat(errorProps);
        analytics.fireEvent({
            category: ANALYTICS_CATEGORY_FLIGHTS,
            action: ANALYTICS_ACTION_FLIGHTS_SEARCH,
            label: data
        });
    }
};


/***/ }),

/***/ 33765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IN": function() { return /* binding */ HOTEL; },
/* harmony export */   "KW": function() { return /* binding */ ONE_WAY; },
/* harmony export */   "N2": function() { return /* binding */ MULTI_DESTINATION; },
/* harmony export */   "Po": function() { return /* binding */ ADD_PRODUCT_OPTIONS; },
/* harmony export */   "RK": function() { return /* binding */ FLIGHT_TYPE_CODE; },
/* harmony export */   "Yt": function() { return /* binding */ FLIGHT_TYPE_INFO; },
/* harmony export */   "cv": function() { return /* binding */ DRIVE; },
/* harmony export */   "iF": function() { return /* binding */ ROUND_TRIP; },
/* harmony export */   "kt": function() { return /* binding */ PRIMARY_HEADING_FALLBACK; },
/* harmony export */   "pH": function() { return /* binding */ CABIN_CLASS; },
/* harmony export */   "wd": function() { return /* binding */ FLY; }
/* harmony export */ });
/* unused harmony exports FLY_DRIVE, STAY_FLY, STAY_FLY_DRIVE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var HOTEL = "STAY";
var FLY = "FLY";
var DRIVE = "DRIVE";
var FLY_DRIVE = "FLY:DRIVE";
var STAY_FLY = "STAY:FLY";
var STAY_FLY_DRIVE = "STAY:FLY:DRIVE";
var ONE_WAY = "one-way";
var ROUND_TRIP = "round-trip";
var MULTI_DESTINATION = "multi-destination";
var CABIN_CLASS = {
    Economy: "ECO",
    "Premium Economy": "PEC",
    Business: "BUS",
    First: "FST"
};
var _obj;
var FLIGHT_TYPE_CODE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ONE_WAY, "OW"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ROUND_TRIP, "RT"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MULTI_DESTINATION, "MD"), _obj);
var _obj1;
var FLIGHT_TYPE_INFO = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, ROUND_TRIP, {
    id: "flight-type-round-trip",
    flightType: ROUND_TRIP,
    typeLabel: "Round-trip"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, ONE_WAY, {
    id: "flight-type-one-way",
    flightType: ONE_WAY,
    typeLabel: "One-way"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, MULTI_DESTINATION, {
    id: "flight-type-multi-destination",
    flightType: MULTI_DESTINATION,
    typeLabel: "Multi-destination"
}), _obj1);
var PRIMARY_HEADING_FALLBACK = "Find your next flight deal";
var ADD_PRODUCT_OPTIONS = [
    {
        name: "hotel",
        type: HOTEL,
        label: "Add a hotel",
        id: "add-a-hotel-checkbox"
    },
    {
        name: "car",
        type: DRIVE,
        label: "Add a car",
        id: "add-a-car-checkbox"
    }
];


/***/ }),

/***/ 47418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LayoutComponentWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88939);



function LayoutComponentWrapper(param) {
    var children = param.children, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    return isUsingNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variation: "100",
        rowGap: "xl",
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
}


/***/ }),

/***/ 360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "GS": function() { return /* binding */ getTextString; },
/* harmony export */   "MI": function() { return /* binding */ onSubmit; },
/* harmony export */   "XU": function() { return /* binding */ fields; },
/* harmony export */   "k7": function() { return /* binding */ CALENDAR_POPOVER_SELECTOR; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57809);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29735);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94738);
/* harmony import */ var _TripTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51217);







var onSubmit = function(values) {
    var ANALYTICS_CATEGORY = values.gaCategory;
    var startLocation = values.startLocation, endLocation = values.endLocation, childrenAges = values.childrenAges, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values, [
        "startLocation",
        "endLocation",
        "childrenAges"
    ]);
    var isPartialStayDateValid = !!rest.partialStay && (rest.hotelStartDate !== rest.startDate || rest.hotelEndDate !== rest.endDate);
    if ((startLocation === null || startLocation === void 0 ? void 0 : startLocation.type) === "AIRPORT" && (startLocation === null || startLocation === void 0 ? void 0 : startLocation.lat) === 0 && (startLocation === null || startLocation === void 0 ? void 0 : startLocation.lon) === 0) {
        startLocation.type = "GDS_CITY";
    }
    if ((endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === "AIRPORT" && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.lat) === 0 && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.lon) === 0) {
        endLocation.type = "GDS_CITY";
    }
    (0,_shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        startLocationObject: startLocation,
        endLocationObject: endLocation,
        childrenAges: childrenAges
    }, rest), {
        isPartialStayDateValid: isPartialStayDateValid && rest.tripType !== _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_DRIVE */ .Hl
    }));
    (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .persistSearchData */ .al)(_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .PACKAGE_SEARCH_DATA */ .Tw, values);
    if (isPartialStayDateValid) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: "VP Search Button",
            label: "Partial search"
        });
    }
    if (rest.isRecommendedTrip) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: "VP Search Button",
            label: "Recommended Trip search"
        });
    }
    if (!isPartialStayDateValid && !rest.isRecommendedTrip) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: "VP Search Button",
            label: "Normal search"
        });
    }
    if (rest.pickupCarSomewhere) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: "H+C - Different Location Search",
            category: ANALYTICS_CATEGORY
        });
    }
    if (!rest.pickupCarIncludeAirport) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: "Hide On Airport Inventory",
            category: ANALYTICS_CATEGORY
        });
    }
};
var getTextString = function(tripType) {
    return function(text) {
        switch(tripType){
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY_DRIVE */ .Ss:
                return "".concat(text, "hotel, flight and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .FLY_DRIVE */ .yv:
                return "".concat(text, "flight and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_DRIVE */ .Hl:
                return "".concat(text, "hotel and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY */ .b:
            default:
                return "".concat(text, "hotel and flight");
        }
    };
};
var CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]';
var initialState = {
    tripType: _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY */ .b,
    partialStay: false,
    startLocation: null,
    endLocation: null,
    startDate: "",
    endDate: "",
    hotelStartDate: "",
    hotelEndDate: "",
    roomCount: 1,
    adultCount: 2,
    childrenCount: 0,
    childrenAges: [],
    isRecommendedTrip: false,
    includeBasicEconomy: true,
    pickupCarSomewhere: false,
    pickupCarIncludeAirport: true,
    rcLocation: null,
    rcPickupDate: "",
    rcDropoffDate: "",
    rcPickupTime: "10:00",
    rcDropoffTime: "10:00",
    gaCategory: ""
};
var fields = [
    "startLocation",
    "endLocation",
    "startDate",
    "endDate",
    "hotelStartDate",
    "hotelEndDate",
    "roomCount",
    "adultCount",
    "childrenCount",
    "childrenAges",
    "tripType",
    "includeBasicEconomy",
    "pickupCarSomewhere",
    "pickupCarIncludeAirport",
    "rcLocation",
    "rcPickupDate",
    "rcDropoffDate",
    "rcPickupTime",
    "rcDropoffTime",
    "gaCategory"
];


/***/ }),

/***/ 29293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StyledHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99278);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97331);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23720);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68464);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"].h1 */ .Z.h1).withConfig({
    componentId: "sc-2bd40273-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_6__/* .textAlign */ .yd, styled_system__WEBPACK_IMPORTED_MODULE_6__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_6__/* .textStyle */ .YK);
var StyledH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"].h2 */ .Z.h2).withConfig({
    componentId: "sc-2bd40273-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_6__/* .alignSelf */ .uk, styled_system__WEBPACK_IMPORTED_MODULE_6__/* .textAlign */ .yd, styled_system__WEBPACK_IMPORTED_MODULE_6__/* .fontWeight */ .Ue, styled_system__WEBPACK_IMPORTED_MODULE_6__/* .space */ .Dh);
var HEADINGS = {
    h1: StyledH1,
    h2: StyledH2
};
function StyledHeading(_param) {
    var _color = _param.color, color = _color === void 0 ? "text.base" : _color, text = _param.text, textAlign = _param.textAlign, tag = _param.tag, textStyle = _param.textStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "color",
        "text",
        "textAlign",
        "tag",
        "textStyle"
    ]);
    var Component = HEADINGS[tag];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var bold = isMobile ? "600" : "700";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        fontWeight: tag === "h2" ? "400" : bold,
        textAlign: textAlign || "left",
        color: color,
        textStyle: textStyle,
        m: 0
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
            children: text
        })
    }));
}


/***/ }),

/***/ 98673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useContentfulSearchFormHeadlines; }
/* harmony export */ });
/* harmony import */ var _useContentfulVariation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49356);

function useContentfulSearchFormHeadlines(name) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var searchForm = (0,_useContentfulVariation__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(name, shouldFireImpression);
    return searchForm !== null && searchForm !== void 0 ? searchForm : null;
}


/***/ }),

/***/ 49356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useContentfulVariation; }
});

// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/useContentful/useContentful.js
var useContentful = __webpack_require__(61388);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/getVariantContent/getVariantContent.js
var getVariantContent = __webpack_require__(57931);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
;// CONCATENATED MODULE: ./src/utils/is-content-ivariation-collection-type.ts
function isContentIVariationCollectionType(content) {
    return content !== undefined && content.experimentName != null && content.experimentName.trim() !== "";
}

;// CONCATENATED MODULE: ./src/hooks/useContentfulVariation.ts



function useContentfulVariation(fieldName) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var content = (0,useContentful/* default */.Z)(fieldName);
    var isVariantCollection = isContentIVariationCollectionType(content);
    var setiName = (0,useSeti/* default */.Z)(isVariantCollection ? content.experimentName : "", shouldFireImpression && isVariantCollection && content.experimentName !== undefined);
    return isVariantCollection ? (0,getVariantContent/* default */.Z)(setiName, content) : content !== null && content !== void 0 ? content : null;
}


/***/ })

}]);